import React, { FC } from 'react'
import { useHistory } from 'react-router'
import { omit } from 'lodash'
import queryString from 'query-string'
import { Button } from 'transfix-ui/components/Button'
import { Box, createStyles, makeStyles } from 'transfix-ui/core'
import { useBreakpointContext } from 'utils/context/BreakpointContext'
import { useFMSAnalytics } from 'apps/fleet-planner/hooks'
import { LoadRecommendation } from 'apps/fleet-planner/types'
import { RightArrowIcon } from 'transfix-icons'
import { useTrackConversionContext } from '../context/track-conversion-source/TrackConversionContext'

interface IViewMoreLikeThisHistoricalLanesButtonProps {
  loadRecommendation: LoadRecommendation
}

const useStyles = makeStyles(() =>
  createStyles<string, { mobile: boolean | undefined }>({
    root: {
      textAlign: ({ mobile }) => (mobile ? 'center' : 'left'),
    },
  })
)

export const ViewMoreLikeThisHistoricalLanesButton: FC<IViewMoreLikeThisHistoricalLanesButtonProps> = ({
  loadRecommendation,
}) => {
  const { trackEvent } = useFMSAnalytics()
  const { setTrackConversion } = useTrackConversionContext()
  const history = useHistory()
  const { isMobile } = useBreakpointContext()
  const classes = useStyles({ mobile: isMobile })
  const openBookLoadsSavedSearchHandler = () => {
    setTrackConversion('web', 'lane_alert_auto_historical')
    trackEvent('Historical Lanes', 'CLICKED_SEE_ALL_LOADS_ON_RUN_IT_AGAIN_PAGE')
    const filters = {
      ...omit(loadRecommendation, [
        'createdAt',
        'sourceType',
        'totalResultCount',
        'unviewedResultCount',
        'recommendations',
        'createdByParentId',
        'subscriberParentIds',
        'recommendationsCount',
        'recommendationsUnviewedCount',
      ]),
    }
    const query = queryString.stringify({
      ...filters,
    })
    history.push(`/book/?${query}`)
  }

  return (
    <Box className={classes.root}>
      <Button
        className='pl0'
        variant='text'
        color='tertiary'
        size='large'
        onClick={openBookLoadsSavedSearchHandler}>
        View More Like This
        {isMobile && <RightArrowIcon />}
      </Button>
    </Box>
  )
}
